import TagManager from '@sooro-io/react-gtm-module'
import { getAnalytics, setUserProperties } from 'firebase/analytics'
import {
  logEvent,
  setAdditionalParams,
} from 'fitify-ui-onboarding/src/utils/analytics'
import { useEffect } from 'react'

import { getFunnelFromWindowLocation } from 'utils/funnel'

setAdditionalParams({ funnel_id: getFunnelFromWindowLocation })

export const useAnalytics = () => {
  useEffect(() => {
    const analytics = getAnalytics()
    const url = new URL(window.location.href)
    const utmSource = url.searchParams.get('utm_source')
    const utmMedium = url.searchParams.get('utm_medium')
    const utmCampaign = url.searchParams.get('utm_campaign')
    const utmContent = url.searchParams.get('utm_content')
    const utmTerm = url.searchParams.get('utm_term')

    TagManager.initialize({
      gtmId: process.env.NEXT_PUBLIC_GTM_ID,
      source: process.env.NEXT_PUBLIC_GTM_SCRIPT_URL,
    })

    setUserProperties(analytics, {
      source: utmSource,
      medium: utmMedium,
      campaign: utmCampaign,
    })

    if (utmSource && utmMedium && utmCampaign) {
      logEvent('utm_conversion', {
        source: utmSource,
        medium: utmMedium,
        campaign: utmCampaign,
        content: utmContent,
        term: utmTerm,
      })
    }
  }, [])
}
